import { render, staticRenderFns } from "./MarketInformation.vue?vue&type=template&id=1b218590&scoped=true&"
import script from "./MarketInformation.vue?vue&type=script&lang=js&"
export * from "./MarketInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b218590",
  null
  
)

export default component.exports